// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__382sM","colMin":"styles_colMin__5gAmy","colCheckbox":"styles_colCheckbox__31ML8"};